<mat-progress-bar  class="audio-progress-bar" mode="determinate" value="{{progress}}"></mat-progress-bar>